// extracted by mini-css-extract-plugin
module.exports = {"CenterCropImg":"CenterCropImg_CenterCropImg__2Y21b","CenterCropImg__img":"CenterCropImg_CenterCropImg__img__bsLd8"};